import { Injectable } from '@angular/core';
import { ViewerUserSettings } from '@core/models/viewer-user-settings.model';
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class ViewerSettingsService {
  userSettingsChanged = new Subject<ViewerUserSettings>();

  getUserSettings() {
    const data = localStorage.getItem('userPreferences');
    if (!data) {
      return new ViewerUserSettings();
    }
    return JSON.parse(data);
  }

  setUserSettings(settings: ViewerUserSettings) {
    console.log('RECEIVED', settings);
    localStorage.setItem('userPreferences', JSON.stringify(settings));
    this.userSettingsChanged.next(settings);
  }
}
